import { render, staticRenderFns } from "./CashierPage.vue?vue&type=template&id=70ae9276&scoped=true&"
import script from "./CashierPage.vue?vue&type=script&lang=js&"
export * from "./CashierPage.vue?vue&type=script&lang=js&"
import style0 from "./CashierPage.vue?vue&type=style&index=0&id=70ae9276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ae9276",
  null
  
)

export default component.exports